export default __webpack_public_path__ + "static/media/modal-search.cc3005ce.svg";